import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {Resource} from '../../graphql/resources.datatypes';

interface ResourcesData {
    allResources: Resource[],
}

export const GET_RESOURCES_QUERY = gql`
  query allResources($where: WhereConditions, $orderBy: [OrderByClause!]){
    allResources(where: $where, orderBy: $orderBy){
      id
      internal_name
      display_name
      resource_type

      resources {
        id
        internal_name
        display_name
        resource_type
      }

      resource_banks {
        id
        resource_id
      }

      options {
        id
        display_name
        internal_name
      }
    }
  }
`;

export const getResources = (where?: any, orderBy?: any) => useQuery<ResourcesData>(
  GET_RESOURCES_QUERY,
  {
    variables: {
      where,
      orderBy,
    },
  }
);

export default getResources;
